import ReactGA from "react-ga4";

import { AppProvider } from "./provider";
import { AppRouter } from "./router";

import type { FC } from "react";

const GOOGLE_ANALYTICS_ID = import.meta.env.VITE_GOOGLE_ANALYTICS_ID;

if (GOOGLE_ANALYTICS_ID) {
  ReactGA.initialize([
    {
      trackingId: GOOGLE_ANALYTICS_ID,
      gaOptions: {
        cookieUpdate: true,
        cookieExpires: 31536000, // 1 year
        anonymizeIp: true,
        page: window.location.pathname,
      },
    },
  ]);
}

export const App: FC = () => {
  return (
    <AppProvider>
      <AppRouter />
    </AppProvider>
  );
};
